<template>
  <div class="content-wrapper">
    <div class="content-header row">
      <div class="content-header-left col-md-9 col-12 mb-2">
        <div class="row breadcrumbs-top">
          <div class="col-12">
            <h2 class="content-header-title float-left mb-0">Paramètres</h2>
            <div class="breadcrumb-wrapper">
              <ol class="breadcrumb">
                <li class="breadcrumb-item"><a href="/administration/dashboard">Accueil</a></li>
                <li class="breadcrumb-item active">Paramètres système</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content-body">
      <section id="basic-tabs-components">
        <div class="row match-height">
          <div class="col-xl-12 col-lg-12">
            <div class="card">
              <div class="card-header border-bottom">
                <h4 class="card-title">Configuration des tarifs et notifications</h4>
              </div>
              <div class="card-body pt-2">
                <ul class="nav nav-tabs" role="tablist">
                  <li class="nav-item">
                    <a class="nav-link active" id="pricing-tab" data-toggle="tab" href="#pricing" aria-controls="pricing" role="tab" aria-selected="true">
                      <i data-feather="dollar-sign"></i> Tarification
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" id="contact-tab" data-toggle="tab" href="#contact" aria-controls="contact" role="tab" aria-selected="false">
                      <i data-feather="mail"></i> Contact & NSIA
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" id="advanced-tab" data-toggle="tab" href="#advanced" aria-controls="advanced" role="tab" aria-selected="false">
                      <i data-feather="settings"></i> Avancé (Prefixes & Règles)
                    </a>
                  </li>
                </ul>
                <div class="tab-content">
                  <!-- Onglet Tarification -->
                  <div class="tab-pane active" id="pricing" aria-labelledby="pricing-tab" role="tabpanel">
                    <div class="mt-2">
                      <div v-for="(item, index) in settings.pricing" :key="index" class="form-group row border-bottom pb-1">
                        <label class="col-sm-3 col-form-label font-weight-bold">{{ formatKey(item.key) }}</label>
                        <div class="col-sm-6">
                          <input type="text" class="form-control" v-model="item.value" />
                          <small class="text-muted" v-if="item.key === 'taxe_rate'">Exemple: 0.06 pour 6%</small>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Onglet Contact -->
                  <div class="tab-pane" id="contact" aria-labelledby="contact-tab" role="tabpanel">
                    <div class="mt-2">
                      <div v-for="(item, index) in settings.contact" :key="index" class="form-group row border-bottom pb-1">
                        <label class="col-sm-4 col-form-label font-weight-bold">{{ formatKey(item.key) }}</label>
                        <div class="col-sm-6">
                          <input type="text" class="form-control" v-model="item.value" />
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Onglet Avancé (Prefixes + Advanced Pricing) -->
                  <div class="tab-pane" id="advanced" aria-labelledby="advanced-tab" role="tabpanel">
                    <div class="mt-2">
                        <h5 class="mb-1 text-primary">Préfixes de polices</h5>
                        <div v-for="(item, index) in settings.prefix" :key="'p'+index" class="form-group row border-bottom pb-1">
                            <label class="col-sm-4 col-form-label font-weight-bold">{{ formatKey(item.key) }}</label>
                            <div class="col-sm-6">
                            <input type="text" class="form-control" v-model="item.value" />
                            </div>
                        </div>

                        <h5 class="mt-2 mb-1 text-primary">Règles métier avancées</h5>
                        <div v-for="(item, index) in settings.advanced_pricing" :key="'a'+index" class="form-group row border-bottom pb-1">
                            <label class="col-sm-4 col-form-label font-weight-bold">{{ formatKey(item.key) }}</label>
                            <div class="col-sm-6">
                            <input type="text" class="form-control" v-model="item.value" />
                            <small class="text-muted" v-if="item.description">{{ item.description }}</small>
                            </div>
                        </div>
                    </div>
                  </div>
                </div>

                <div class="mt-3">
                  <button class="btn btn-primary" @click="saveSettings" :disabled="loading">
                    <span v-if="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    <i data-feather="save" class="mr-25" v-else></i>
                    Enregistrer les modifications
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { api } from '../../../helpers/shared';

export default {
  data() {
    return {
      settings: {
        pricing: [],
        contact: [],
        general: []
      },
      loading: false
    }
  },
  mounted() {
    this.fetchSettings();
    if (window.feather) {
      window.feather.replace();
    }
  },
  methods: {
    fetchSettings() {
      // Note: On utilise le préfixe 'api/' car cette route est définie dans api.php
      axios.get(api('api/settings')).then(res => {
        if (res.data.status) {
          this.settings = res.data.settings;
        }
      }).catch(err => {
        console.error("Erreur lors de la récupération des paramètres", err);
      });
    },
    saveSettings() {
      this.loading = true;
      axios.post(api('api/settings/update'), { settings: this.settings }).then(res => {
        this.loading = false;
        if (res.data.status) {
          this.$toasted.global.all({ message: res.data.message });
        }
      }).catch(err => {
        this.loading = false;
        this.$toasted.global.error({ message: "Erreur lors de la sauvegarde" });
      });
    },
    formatKey(key) {
      const labels = {
        'taxe_rate': 'Taux de Taxe',
        'frais_dossier': 'Frais de Dossier',
        'avenant_annual': 'Frais Avenant (Annuel)',
        'avenant_short': 'Frais Avenant (Court terme)',
        'notification_email': 'Email de notification',
        'support_phone': 'Téléphone Support',
        'address': 'Adresse physique',
        'surprime_seat_rate': 'Taux Surprime par Siège (Auto)',
        'cost_per_animal': 'Coût par animal (MRH)',
        'moto_surprime_personnel': 'Surprime Moto (Personnel)',
        'moto_surprime_taxi': 'Surprime Moto (Taxi)',
        'cedeao_price': 'Prix Garantie CEDEAO',
        'moto_police_frais': 'Frais Police (Moto fixe)',
        'prefix_habitation': 'Préfixe Police Habitation',
        'prefix_voyage': 'Préfixe Police Voyage',
        'support_phone': 'Téléphone Support Client',
        'support_email': 'Email Support Client',
        'address_nsia': 'Adresse Physique NSIA',
        'cat4_seat_increase_rate': 'Taux Majorat. Siège (Cat 4)',
        'cat4_sub22_min_premium_10_15': 'Forfait Cat 4 (10-15 pl.)',
        'cat4_sub22_min_premium_16_20': 'Forfait Cat 4 (16-20 pl.)',
        'cat4_sub22_extra_seat_above_20': 'Prix Place sup. (>20 pl.)',
        'guarantee_extra_fees_rate': 'Multipl. Frais Accessoires'
      };
      return labels[key] || key.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
    }
  }
}
</script>

<style scoped>
.nav-tabs .nav-link i {
  margin-right: 5px;
  width: 14px;
  height: 14px;
}
</style>
